var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 92,
    viewBox: "0 0 90 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.5598 74.735C66.7207 80.2267 58.1144 83.4964 48.7483 83.4964C47.2462 83.4964 45.7794 83.4061 44.3303 83.2435C39.0287 82.6473 36.7138 76.126 40.4249 72.224L58.6976 53.0394C64.2819 47.1684 67.6926 39.5451 68.2228 31.705L68.5232 27.2611C68.6646 25.1295 66.8974 23.3772 64.8298 23.5759L60.5002 24.0095C52.8659 24.7682 45.4967 28.4534 39.8947 34.3244L20.4025 54.7916C16.9035 58.4588 10.7889 56.7787 9.64025 51.7929C8.95104 48.7761 8.59766 45.6509 8.59766 42.4173C8.59766 40.9722 8.66834 39.5631 8.80972 38.1541",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7285 17.5966C24.2568 7.4804 36.2561 1.03131 49.7221 1.35648C71.4763 1.88035 89.0422 20.3605 88.9362 42.6161C88.9008 48.3426 87.7344 53.7801 85.6491 58.7298",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.632 59.8225L5.34258 73.8507C4.56856 74.6678 4.58625 75.9686 5.38203 76.7564C6.17781 77.5441 7.45032 77.5204 8.22433 76.7034L21.5138 62.6752C22.2878 61.8581 22.2702 60.5572 21.4744 59.7694C20.6786 58.9817 19.4061 59.0055 18.632 59.8225Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.0996 66.2246L5.40508 87.0139C4.63106 87.831 4.64876 89.1318 5.44454 89.9196C6.24031 90.7073 7.51282 90.6836 8.28683 89.8666L27.9813 69.0773C28.7554 68.2602 28.7377 66.9593 27.942 66.1715C27.1462 65.3838 25.8736 65.4075 25.0996 66.2246Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.5603 72.6184L18.2709 86.6466C17.4968 87.4637 17.5145 88.7646 18.3102 89.5524C19.106 90.3401 20.3786 90.3164 21.1526 89.4993L34.4421 75.4711C35.2161 74.6541 35.1985 73.3531 34.4027 72.5653C33.607 71.7776 32.3344 71.8014 31.5603 72.6184Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M50.4019 48.3447C53.3735 48.3447 55.7824 45.8823 55.7824 42.8447C55.7824 39.8071 53.3735 37.3447 50.4019 37.3447C47.4304 37.3447 45.0215 39.8071 45.0215 42.8447C45.0215 45.8823 47.4304 48.3447 50.4019 48.3447Z",
    fill: "#236F5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1 31.6875C1 28.9959 3.12063 26.8281 5.75375 26.8281C8.38687 26.8281 10.5075 28.9959 10.5075 31.6875",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.5078 31.6872C10.5078 28.9956 12.6285 26.8279 15.2616 26.8279C17.8947 26.8279 20.0153 28.9956 20.0153 31.6872",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M69.1074 69.4053C69.1074 66.7136 71.2281 64.5459 73.8612 64.5459C76.4943 64.5459 78.615 66.7136 78.615 69.4053",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M78.6152 69.4055C78.6152 66.7139 80.7358 64.5461 83.3689 64.5461C86.002 64.5461 88.1227 66.7139 88.1227 69.4055",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSvg3);
export default __webpack_public_path__ + "static/media/offer-svg-3.ff704ca8cb6e69f0029d11ae63ab8549.svg";
export { ForwardRef as ReactComponent };